import React from "react";

const ImageQuestion = ({ question, answer, onAnswer }) => {
  return (
    <div>
      <h2 className="font-bold text-lg text-gray-800 mb-4">{question.text}</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {question.options.map((img, i) => (
          <img
            key={i}
            src={img}
            alt={`گزینه ${i + 1}`}
            className={`cursor-pointer border-4 rounded-md ${
              answer === i ? "border-blue-500" : "border-transparent"
            }`}
            onClick={() => onAnswer(i)}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageQuestion;
